// extracted by mini-css-extract-plugin
export default {"whychoose-img":"whychooseimage_whychoose-img__TIz6x"};